import type { LayerKey } from '@festina-life/api'

import type { EnumMetaType } from '../../types/metaModel'
import type { EnumDefinition, EnumLiteral } from './types'

export const modeledEnumToEnumDefinition = ({
  modeledEnum,
  layer,
  block,
}: {
  modeledEnum: EnumMetaType
  layer: LayerKey
  block: string
}): EnumDefinition => ({
  name: modeledEnum.typeName,
  internalOperation: undefined,
  changesetHistory: undefined,
  layer,
  block,
  errors: [],
  isDraft: false,
  actions: [],
  annulOperations: [],
  literals:
    modeledEnum.values?.map((literalName) => ({
      literalName,
      type: 'modeled',
      enumDefinition: modeledEnum,
    })) ?? [],
})

export const getLiteralName = (literal: EnumLiteral) =>
  literal.type === 'modeled'
    ? literal.literalName
    : (literal.internalOperation.entity?.name ?? '')
